import React from 'react';

// components

import LanguageSwitch, { LanguageSwitchProps } from '@components/common/headers/utils/LanguageSwitchContainer';
import { SkipMainContent } from '@components/common/headers/utils';
import { HeaderNav, NavBar } from 'app-components';
import GASubMenu from './GASubMenu';

// props

interface Props {
    environment: any;
}

function HeaderContainer(props: Props) {

    const {
        environment,
        environment: {
            anonymous,
            language,
            impersonation,
            stateCode,
            links: {
                LOGIN,
                LOGOUT,
                LOGO_URL: logoUrl,
            },
            user
        }
    } = props;

    const languageProps: LanguageSwitchProps = {
        details: {
            name: 'language',
            text: 'header.lang',
        },
        index: 0,
        environment: {
            language,
            user,
            impersonation
        }
    };

    const LoggedInMenu = () => {
        return (
            <>
                <NavBar.Item>
                    <NavBar.Link id={'account_2'} url={logoUrl}  labelId={'header.account'} />
                </NavBar.Item>
                <NavBar.Item>
                    <NavBar.Link id={'logout_3'} url={LOGOUT}  labelId={'header.myAccount.logout'} />
                </NavBar.Item>
            </>
        );
    };

    const NotLoggedInMenu = () => {
        return (
            <NavBar.Item>
                <NavBar.Link id={'login_1'} url={LOGIN}  labelId={'header.login'} />
            </NavBar.Item>
        );
    };

    const isLoggedIn = !anonymous && !impersonation;

    return (
        <>
            <SkipMainContent />
            <HeaderNav isTopNav={true} stateCode={stateCode} hasSubMenu={false}>
                <NavBar>
                    <LanguageSwitch { ...{ ...languageProps } }/>
                    {
                        isLoggedIn && <LoggedInMenu />
                    }
                    {
                        !isLoggedIn && <NotLoggedInMenu />
                    }
                </NavBar>
            </HeaderNav>
            <GASubMenu isLoggedIn={isLoggedIn} environment={environment} />
        </>
    );
}
export default HeaderContainer;